import { UAParser } from 'ua-parser-js';

export interface DeviceFingerprint {
  deviceId: string;
  osName: string;
  osVersion: string;
  browserName: string;
  browserVersion: string;
  screenResolution: string;
  timezone: string;
  language: string;
  platform: string;
}

export function generateDeviceFingerprint(): DeviceFingerprint {
  const parser = new UAParser();
  const result = parser.getResult();

  const fingerprint: DeviceFingerprint = {
    deviceId: generateDeviceId(),
    osName: result.os.name || 'Unknown',
    osVersion: result.os.version || 'Unknown',
    browserName: result.browser.name || 'Unknown',
    browserVersion: result.browser.version || 'Unknown',
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    platform: navigator.platform,
  };

  return fingerprint;
}

export function generateDeviceId(): string {
  const parser = new UAParser();
  const result = parser.getResult();

  const components = [
    result.os.name,
    result.os.version,
    result.browser.name,
    result.browser.version,
    navigator.language,
    window.screen.width,
    window.screen.height,
    new Date().getTimezoneOffset(),
  ];

  const seed = components.join('|');
  return btoa(seed).substring(0, 32);
}

export function getDeviceName(fingerprint: DeviceFingerprint): string {
  const { osName, browserName } = fingerprint;

  if (osName?.includes('Mac')) return `${browserName} on Mac`;
  if (osName?.includes('Windows')) return `${browserName} on Windows`;
  if (osName?.includes('iOS')) return `${browserName} on iPhone`;
  if (osName?.includes('Android')) return `${browserName} on Android`;
  if (osName?.includes('Linux')) return `${browserName} on Linux`;

  return `${browserName} on ${osName}`;
}
